import { Cookies } from './get-cookies';

export function getAuthenticationFromCookies(
    cookies: Cookies | null,
    authenticationCookieName: string
): { isAuthenticated: string } | null {
    if (cookies === null || !cookies.has(authenticationCookieName)) {
        return null;
    }

    const isAuthenticated = cookies.get(authenticationCookieName);
    if (!isAuthenticated) {
        return null;
    }

    return { isAuthenticated };
}
